module.exports = __webpack_public_path__ + "img/layout_ladder.1961821b.svg";